import { render, staticRenderFns } from "./viewCompanyVehicle.vue?vue&type=template&id=38c878e2&"
import script from "./viewCompanyVehicle.vue?vue&type=script&lang=js&"
export * from "./viewCompanyVehicle.vue?vue&type=script&lang=js&"
import style0 from "./viewCompanyVehicle.vue?vue&type=style&index=0&id=38c878e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports